/*

  settings to account for

  - [X] auto
  - [X] program (application)
  - [x] analog inputs
    - [x] mode
    - [x] test 1
    - [x] test 2
  - [x] digital inputs
    - [x] mode
  - [x] com source
  - [X] schedule

*/

import React, { useState, useEffect, useCallback } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { SelectInput } from '../Inputs/Inputs'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

import styles from '../../../../css/settings.module.css'

const COMM_SOURCE_VALID = [
  { name: 'No Comm Source', value: '0' },
  { name: 'Yaskawa iQPump1000 MODBUS', value: 'y' },
]

const DEFAULT_SETTINGS = {
  com_source: '0',
}

function Pump (props) {
  const defaultSettings = { settings: { ...DEFAULT_SETTINGS } }

  const {
    device: {
      application_settings: applicationSettings = defaultSettings,
      application_settings_new: applicationSettingsNew = defaultSettings,
    } = {},
    device,
    setValidity,
  } = props

  const {
    settings: {
      com_source = DEFAULT_SETTINGS.com_source,
    } = {},
  } = applicationSettings

  const {
    settings: {
      com_source: new_com_source,
    } = {},
  } = applicationSettingsNew

  const [formIsValid, setFormIsValid] = useState(true)
  const [invalidFields, setInvalidFields] = useState({})
  const [comSource, setComSource] = useState(new_com_source || com_source)

  const appDispatch = useCallback(() => {
    const { address } = device

    const settings = {
      address,
      status: 'new',
      settings: {
        com_source: comSource,
      },
    }

    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: settings,
    })
  }, [device, comSource])

  useEffect(() => {
    appDispatch()
  }, [comSource])

  const childChange = useCallback((event) => {
    const { target: { name, value, validity: { valid } } } = event
    let newValue = value

    switch (name) {
      case 'com_source':
        if (COMM_SOURCE_VALID.find((item) => item.value === value)) {
          // nothing to do here
        } else {
          newValue = DEFAULT_SETTINGS[name]
        }
        setComSource(newValue)
        break
      default:
        return
    }

    const newInvalidFields = { ...invalidFields }

    if (valid) {
      delete newInvalidFields[name]
    } else {
      newInvalidFields[name] = true
    }

    const newFormIsValid = Object.keys(newInvalidFields).length === 0

    setInvalidFields(newInvalidFields)
    setFormIsValid(newFormIsValid)
    setValidity(newFormIsValid)
  }, [invalidFields, setValidity, appDispatch])

  return (
    <div>
      <section className={styles.heading}>
        <h3>
          <FormattedMessage
            id='setting.pump.communication.label'
            defaultMessage='Communication Settings'
            description='Communication Settings label'
          />
        </h3>
      </section>
      <div className={styles.inputArea}>
        <section>
          <h5>
            <FormattedMessage
              id='setting.pump.commSource.label'
              defaultMessage='Comm Source'
              description='Comm Source label'
            />
          </h5>
          <div className={styles.controlSelect}>
            <SelectInput
              value={comSource}
              options={COMM_SOURCE_VALID}
              childChange={childChange}
              field='com_source'
              style={styles.controlSelectInput}
            />
          </div>
        </section>
      </div>
    </div>
  )
}

Pump.propTypes = {
  device: PropTypes.object.isRequired,
  setValidity: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
}

export default injectIntl(Pump)
